// @flow
import React from 'react';
import { TABLEFLOW_RESOURCES_GRID_HEADERS } from '@streaming-projects/orgs/enums';

import { DeleteRenderer } from '../../../views/grid-utils/renderers';

import { SPTableFlowResourceDeleteWarningModal } from './SPTableFlowResourceDeleteWarningModal';

export const SPTableFlowDeleteRenderer = ({ data }) => {
  return (
    <DeleteRenderer>
      {(isDeleteModalOpen, setDeleteModalOpen) => {
        return (
          <SPTableFlowResourceDeleteWarningModal
            isOpen={isDeleteModalOpen}
            onClose={() => setDeleteModalOpen(false)}
            tableFlowResourceId={data[TABLEFLOW_RESOURCES_GRID_HEADERS.ID]}
            tableFlowResourceName={data[TABLEFLOW_RESOURCES_GRID_HEADERS.NAME]}
            version={data.Version}
          />
        );
      }}
    </DeleteRenderer>
  );
};
